import type { ReactNode } from 'react';

import {
  AccordionContainerElement,
  AccordionContentElement,
  AccordionElement,
  AccordionTitleElement,
  type TAccordionContainerElement,
  type TAccordionContentElement,
  type TAccordionElement,
  type TAccordionTitleElement,
} from '@shared/dream-components';

interface AccordionProps {
  node: TAccordionElement;
  children: ReactNode | ReactNode[];
}

export const Accordion = ({ node, children }: AccordionProps) => {
  return <AccordionElement element={node}>{children}</AccordionElement>;
};

interface AccordionContainerProps {
  node: TAccordionContainerElement;
  children: ReactNode | ReactNode[];
}

export const AccordionContainer = ({ node, children }: AccordionContainerProps) => {
  return <AccordionContainerElement element={node}>{children}</AccordionContainerElement>;
};

interface AccordionTitleProps {
  node: TAccordionTitleElement;
  children: ReactNode | ReactNode[];
}

export const AccordionTitle = ({ node, children }: AccordionTitleProps) => {
  return <AccordionTitleElement element={node}>{children}</AccordionTitleElement>;
};

interface AccordionContentProps {
  node: TAccordionContentElement;
  children: ReactNode | ReactNode[];
}

export const AccordionContent = ({ node, children }: AccordionContentProps) => {
  return <AccordionContentElement element={node}>{children}</AccordionContentElement>;
};
